import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-41-manish-jain-guest.webp";
import ThumbImg from "../../assets/images/conversations/041.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: mj-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .mj-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .mj-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .mj-hero { padding-top: 60px; padding-bottom: 60px; }
  .mj-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .mj-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .mj-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .mj-hero__title.mj-visible { opacity: 1; transform: translateY(0); }
  .mj-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .mj-hero__spotify.mj-visible { opacity: 1; transform: translateY(0); }
  .mj-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .mj-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .mj-hero__right.mj-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .mj-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .mj-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .mj-yt-thumb:hover img { opacity: 0.85; }
  .mj-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .mj-yt-thumb__play img { width: 40px; height: 44px; }
  .mj-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .mj-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .mj-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .mj-body.mj-visible { opacity: 1; transform: translateY(0); }
  .mj-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .mj-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .mj-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .mj-guest.mj-visible { opacity: 1; transform: translateY(0); }
  .mj-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .mj-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .mj-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .mj-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .mj-inner { padding-left: 32px; padding-right: 32px; }
    .mj-hero { padding-top: 32px; padding-bottom: 48px; }
    .mj-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .mj-hero__title { font-size: 24px; }
    .mj-hero__left { gap: 16px; }
    .mj-guest__title { font-size: 24px; margin-bottom: 24px; }
    .mj-guest__photo-bg { width: 260px; height: 300px; }
    .mj-guest__name { font-size: 24px; margin-top: 18px; }
    .mj-body__para { font-size: 14px; margin-bottom: 12px; }
    .mj-body { padding-bottom: 48px; }
    .mj-guest { padding-bottom: 48px; }
    .mj-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .mj-inner { padding-left: 16px; padding-right: 16px; }
    .mj-hero { padding-top: 51px; padding-bottom: 30px; }
    .mj-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .mj-hero__left { gap: 30px; }
    .mj-hero__title { font-size: 30px; }
    .mj-body__para { font-size: 16px; margin-bottom: 10px; }
    .mj-guest__title { font-size: 30px; margin-bottom: 20px; }
    .mj-guest__photo-bg { width: 100%; height: 386px; }
    .mj-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .mj-body { padding-bottom: 30px; }
    .mj-guest { padding-bottom: 30px; }
    .mj-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mj-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "hb2_R6W9gSc";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="mj-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 41 Manish Jain"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="mj-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 41 Manish Jain thumbnail" />
      <div className="mj-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="mj-hero">
      <div className="mj-inner">
        <div className="mj-hero__grid">
          <div className="mj-hero__left">
            <h1 ref={titleRef} className="mj-hero__title">
              From EP 41 | Shaadi.com to EVs – Chat with a EV Super User | Manish Jain
            </h1>
            <div ref={spotifyRef} className="mj-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/4qayijg8Q4HtePUTsntmiX?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 41 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="mj-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="mj-body">
      <div className="mj-inner">
        <p className="mj-body__para">
          On this show, we typically speak to protagonists who are making policy decisions, regulatory decisions, manufacturing cars, or running a power grid. Sometimes, they are involved in battery production or various aspects of the clean mobility value chain. Every now and then, we have the privilege to speak with super users of electric vehicles to discuss problems, challenges, opportunities, comparisons, and the joys of driving electric vehicles. Today, this is one of those special shows. We are speaking with Manish Jain. Manish co-founded Shaadi.com and later, even M Profit, names that are almost synonymous with anyone in the tech space. Manish shares his experience of driving a Tesla Model S Plaid and how he came about to own a KIA EV6. Tune in today! this special episode, we talk about the Funding Winter, major deals this year from January to August, the categories that are doing well, and much more.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="mj-guest">
      <div className="mj-inner">
        <h2 className="mj-guest__title">Our Guest</h2>
        <div>
          <div className="mj-guest__photo-bg">
            <img src={GuestImg} alt="Manish Jain" />
          </div>
          <p className="mj-guest__name">Manish Jain</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep41ManishJain() {
  return (
    <>
      <style>{CSS}</style>
      <div className="mj-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}